export default __webpack_public_path__ + "static/media/background1.ea6ab6f0.webp";